import api from "../../instance/api";
import {
  errorCreateMember,
  errorGetMember,
  startCreateMember,
  startGetMember,
  successCreateMember,
  successGetMember,
} from "../../slice/Member";
import {
  startGetProfile,
  successGetProfile,
  errorGetProfile,
} from "../../slice/Member/MemberProfileSlice";

const createMemberApi = (payload) => async (dispatch) => {
  dispatch(startCreateMember());
  try {
    const res = await api.post(`client`, payload);
    dispatch(successCreateMember(res.data));
  } catch (err) {
    console.log("API error:", err?.response?.data);

    const apiError = err?.response?.data;
    const errorMsg =
      apiError?.errorResponse?.errorMessage ||
      apiError?.payload ||
      apiError?.message ||
      "Something went wrong";

    dispatch(errorCreateMember(errorMsg));
  }
};


const getMemberApi = () => async (dispatch) => {
  dispatch(startGetMember());
  try {
    // ✅ Match working Postman URL & fetch all (large size)
    const res = await api.get(
      `/user/admin-users-list?page=0&size=5000` // Increase size for all records
    );

    // ✅ Pass actual data to Redux store
    dispatch(successGetMember(res.data || []));

    console.log("res======>", res.data);
  } catch (err) {
    dispatch(errorGetMember(err?.response?.data?.message || "Something went wrong"));
    console.log("Download error:", err);
  }
};

/**
 * Fetch member profile data
 * API: GET /user (same as mobile app)
 */
const getMemberProfileApi = () => async (dispatch) => {
  dispatch(startGetProfile());
  try {
    const res = await api.get(`/user`);
    dispatch(successGetProfile(res.data));
  } catch (err) {
    const apiError = err?.response?.data;
    const errorMsg =
      apiError?.message ||
      apiError?.payload ||
      "Failed to fetch profile data";
    dispatch(errorGetProfile(errorMsg));
    console.log("Profile fetch error:", err);
  }
};

export { createMemberApi, getMemberApi, getMemberProfileApi };

